import React from 'react';
import './what-is-freshfund-judges.scss';

const WhatIsFreshFundJudgesIntro = () => (
  <div className='what-is-freshfund-judges-intro'>
    <div className='what-is-freshfund-judges-intro__text'>
      <div className='what-is-freshfund-judges-intro__heading'>
        <h1>MEET THIS YEAR’S INCREDIBLE PANEL</h1>
        <p>Influential business owners. Judges. Humans.</p>
      </div>
      <p>
        They’ll be seeing your applications (so make them sparky!) and the potential in your vision.
        Read their stories here.
      </p>
    </div>
  </div>
);

export default WhatIsFreshFundJudgesIntro;
